import { User } from '.';

export enum EmploymentType {
  EMPLOYED = 'employed',
  SELF_EMPLOYED = 'self_employed',
}

export type Location = {
  address: string;
  city: string;
  country_id: number;
  state_id: number;
};

export interface Country {
  id: number;
  name: string;
  code: string;
  created_at: string;
  updated_at: string;
}

export interface State {
  id: number;
  name: string;
  country_id: number;
  created_at: string;
  updated_at: string;
  country: Country;
}

export type Business = {
  name: string;
  location: {
    city: string;
    state_id: number;
    country_id: number;
    state_name?: string;
    country_name?: string;
  };
  job_title: string;
  duration: number;
  rc_no: string;
  business_type: string;
};

export type Employer = {
  name: string;
  location: {
    city: string;
    state_id: number;
    state_name?: string;
    country_name?: string;
    country_id: number;
  };
  job_title: string;
  duration: number;
};

export interface BorrowerDto {
  location: Location;
  occupation: string;
  is_self_employed: boolean;
  business?: Business;
  employer?: Employer;
  linkedin?: string;
  bvn?: string;
  nin?: string;
  income_prove?: FileList;
  work_prove?: FileList;
}

export interface BorrowerProfileFormValues {
  address?: string;
  bvn?: string;
  city?: string;
  country?: string;
  first_name?: string;
  last_name?: string;
  employer_city?: string;
  employer_country?: string;
  employer_name?: string;
  employer_state?: string;
  employment_type?: string;
  employment_duration?: string;
  business_city?: string;
  business_country?: string;
  business_name?: string;
  business_state?: string;
  business_type?: string;
  business_duration?: string;
  rc_no?: string;
  employment_status?: string;
  income_prove?: FileList;
  job_title?: string;
  linkedin?: string;
  nin?: string;
  occupation: string;
  state?: string;
  work_prove?: FileList;
}

export interface Borrower {
  id: number;
  user_id: number;
  address: string;
  address_city: string;
  address_state_id: number;
  address_country_id: number;
  occupation: string;
  is_self_employed: boolean;
  employer_name?: string;
  employer_city?: string;
  employer_state_id?: number;
  employer_country_id?: number;
  business_name?: string;
  business_city?: string;
  business_state_id?: number;
  business_country_id?: number;
  duration?: number;
  job_title?: string;
  rc_no?: string;
  business_type?: string;
  linkedin?: string;
  bvn?: string;
  nin?: string;
  income_prove?: string;
  work_prove?: string;
  bvn_verified?: boolean;
  nin_verified?: boolean;
  created_at?: string;
  updated_at?: string;
  user: User;
  address_state: State;
  address_country: Country;
  employer_state?: State;
  employer_country?: Country;
  business_state?: State;
  business_country?: Country;
}

export interface BorrowerProfileState {
  profile: Borrower | null;
}
